import { Inject, Optional, Provider, SkipSelf } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  AnalyticsViewContext,
  ANALYTICS_VIEW_CONTEXT,
  ANALYTICS_VIEW_CONTEXT_LEAF,
} from './analytics.types';

export const analyticsContextFactory = (
  contextName: string,
  parentContext?: string[],
): string[] => [...(parentContext || []), contextName];

export function provideAnalyticsViewContext(viewContext: AnalyticsViewContext): Provider[] {
  return [
    {
      provide: ANALYTICS_VIEW_CONTEXT_LEAF,
      useValue: viewContext,
    },
    {
      provide: ANALYTICS_VIEW_CONTEXT,
      useFactory: analyticsContextFactory,
      deps: [
        [new Inject(ANALYTICS_VIEW_CONTEXT_LEAF)],
        [new SkipSelf(), new Optional(), new Inject(ANALYTICS_VIEW_CONTEXT)],
      ],
    },
  ];
}

export const analyticsRouterContextFactory = (
  contextFromRoute?: string,
  parentContext?: string[],
): string[] => [...(parentContext || []), contextFromRoute!].filter(Boolean);

export const analyticsContextFormRouterFactory = (route: ActivatedRoute) => {
  const viewContext: AnalyticsViewContext = route.snapshot.data.viewContext;
  return viewContext;
};

export function provideAnalyticsViewContextFromRouterData(): Provider[] {
  return [
    {
      provide: ANALYTICS_VIEW_CONTEXT_LEAF,
      useFactory: analyticsContextFormRouterFactory,
      deps: [ActivatedRoute],
    },
    {
      provide: ANALYTICS_VIEW_CONTEXT,
      useFactory: analyticsRouterContextFactory,
      deps: [
        [new Inject(ANALYTICS_VIEW_CONTEXT_LEAF)],
        [new SkipSelf(), new Optional(), new Inject(ANALYTICS_VIEW_CONTEXT)],
      ],
    },
  ];
}
